import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {Tooltip} from '@material-ui/core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import styled from "styled-components";

import shellIcon from '../../../assets/logos/shell.png'
import urls from "../../../utils/urls";
import './styles.scss';
import {openMobileSidebar, closeMobileSidebar} from "../../../actions/mobile_actions";
import ProfileImage from "../../../components/profileImage/ProfileImage";

const sideBarJSX = {
    dashboard: <FontAwesomeIcon icon="chart-bar" color={"#CCCCCC"} size="2x"/>,
    ost: <FontAwesomeIcon icon="list" color={"#CCCCCC"} size="2x"/>,
    'p&l': <div className={'side-text'}>P&L</div>,
    hsse: <div className={'side-text'}>HSSE</div>,
    cpm: <div className={'side-text'}>CPM</div>,
    visits: <img src={`${urls.API_ROOT}/static/img/pin.png`} alt={'S.V.'} style={{width: 22}}/>,
    dashslp: <img src={`${urls.API_ROOT}/static/img/franchise.png`} alt={'SLP.'} style={{width: 22}}/>,
    contracts: <FontAwesomeIcon icon="handshake" color={"#CCCCCC"} size="2x"/>,
    prices: <FontAwesomeIcon icon="money-bill" color={"#CCCCCC"} size="2x"/>,
    informer: <img src={`${urls.API_ROOT}/static/img/price_informer_logo_2.png`} alt={'Inf.P.'} style={{width: 28}}/>,
    admin: <FontAwesomeIcon icon="cog" color={"#CCCCCC"} size="2x"/>,
    notifications: <FontAwesomeIcon icon="exclamation-circle" color={"#CCCCCC"} size="2x"/>,
    monitor: <img src={`${urls.API_ROOT}/static/img/monitor.png`} alt={'S.S.'} style={{width: 39}}/>
};

const StyledTooltip = styled(props => (
    <Tooltip
        classes={{ popper: props.className, tooltip: "tooltip" }}
        {...props}
    />
))`
  & .tooltip {
    color: #fff;
    font-size:14px;
  }
`;


class Sidebar extends Component {

    renderSidebar = () => {
        let {user, mobile} = this.props;
        return (
            <div className={'main-sidebar'}>
                <div className={'sidebar-logo'}>
                    <a href={urls.API_ROOT} className={'brand'}>
                        <img src={shellIcon} alt={'Shell'}/>
                    </a>
                </div>

                {mobile.isMobile &&
                <div className={`sidebar-item`}>
                    <a href={`${urls.SSO_URL}`}>
                        <ProfileImage user={user}/>
                    </a>
                </div>
                }
                {user.modules.map((module, i) => {
                    let url = `${urls.API_ROOT}${module.url}`;
                    if (module.url.indexOf("//") === 0) url = module.url;

                    let pathname = window.location.pathname;
                    let active = false;

                    if (module.code === 'visits' && pathname.indexOf('/site-visits') > -1) active = true;
                    if (module.code === 'dashslp' && pathname.indexOf('/dashboard-slp') > -1) active = true;

                    return (
                        <div className={`sidebar-item  ${active ? 'active' : ''} `} key={i}>
                            {/* TODO - MEJORAR TOOLTIPS - VER TAMAÑO */}
                            <StyledTooltip title={module.name} placement="left">
                                <a href={url}>
                                    {active && <div className={'active-bar'}/>}
                                    {sideBarJSX[module.code]}
                                </a>
                            </StyledTooltip>
                        </div>
                    )
                })}
                {mobile.isMobile &&
                    <div className={`sidebar-item`}>
                        <a href={`${urls.API_ROOT}/logout`}>
                            <FontAwesomeIcon icon="sign-out-alt" color={"#CCCCCC"} size="2x"/>
                        </a>
                    </div>
                }
            </div>
        )
    };

    render() {

        let {user, mobile} = this.props;
        if (!user || !user.first_name) return <div/>;

        if (mobile.isMobile) {

            if(!mobile.sidebarOpen){
                return (
                    <div className={'mobile-sidebar'}>
                        <button onClick={this.props.openMobileSidebar}>
                            <FontAwesomeIcon icon="bars" color={"#FFFFFF"} />
                        </button>
                    </div>
                );
            }

            return (
                <div className={'mobile-sidebar'}>
                    {this.renderSidebar()}
                    <div className={'mobile-background-sibebar'}
                         onClick={this.props.closeMobileSidebar} />
                </div>
            );
        }

        return this.renderSidebar();
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        mobile: state.mobile
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({openMobileSidebar, closeMobileSidebar}, dispatch);
};


export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);


// WEBPACK FOOTER //
// ./src/containers/general/sidebar/Sidebar.js